import httpClient  from '.';

export default {
    //Get danh sách mã chứng khoán
    async getSecListAll(lang) {
        let url = '/pbapi/api/secListAll';
        let res = await httpClient.post(url, { lang: lang });
        let data = JSON.parse(res.data);
        let list = JSON.stringify(data.dict).replaceAll('{', '').replaceAll('}', '').split(',');
        let result = [];
        for(let i = 0; i < list.length; i++){
            result.push({ code: list[i].replaceAll('"', '').split(':')[0], name: list[i].replaceAll('"', '').split(':')[1] } );
        }

        return { status: 200, data: result };
    },
}